
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getScoringRecordPreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scoringRecordItems"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"getScoringRecordPreviewInputItem"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lowHcpi"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hcpiBreak"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getScoringRecordPreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"scoringRecordItems"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scoringRecordItems"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lowHcpi"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lowHcpi"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"hcpiBreak"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hcpiBreak"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scoringRecordItems"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scorecard"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nine_hole_cr_doubled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"course_hcpi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"score_differential_pre_pcc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pcc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"score_differential_post_pcc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"exceptional_score"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"exceptional_score_reduction"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"exceptional_score_difference"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"score_differential_exceptional_score_reduction"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"score_differential"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lowest_score_differential"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"soft_cap"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hard_cap"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"calculated_hcpi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hcpi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hcpi_without_breaks"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hcpi_increase_limit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lowest_hcpi_smaller_new_hcpi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"low_hcpi_changed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"new_low_hcpi"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":836}};
    doc.loc.source = {"body":"query getScoringRecordPreview(\n  $scoringRecordItems: [getScoringRecordPreviewInputItem]!\n  $lowHcpi: Float\n  $hcpiBreak: Boolean\n) {\n  getScoringRecordPreview(\n    input: {\n      scoringRecordItems: $scoringRecordItems\n      lowHcpi: $lowHcpi\n      hcpiBreak: $hcpiBreak\n    }\n  ) {\n    scoringRecordItems {\n      scorecard\n      nine_hole_cr_doubled\n      course_hcpi\n      score_differential_pre_pcc\n      pcc\n      score_differential_post_pcc\n      exceptional_score\n      exceptional_score_reduction\n      exceptional_score_difference\n      score_differential_exceptional_score_reduction\n      score_differential\n      lowest_score_differential\n    }\n    soft_cap\n    hard_cap\n    calculated_hcpi\n    hcpi\n    hcpi_without_breaks\n    hcpi_increase_limit\n    lowest_hcpi_smaller_new_hcpi\n    low_hcpi_changed\n    new_low_hcpi\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getScoringRecordPreview"] = oneQuery(doc, "getScoringRecordPreview");
        
